import React, { useEffect, useCallback, useState } from "react";
import { makeStyles } from "@material-ui/styles";

// styles
import useStyles, { getMuiTheme } from "./styles";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { Tabs, Tab,IconButton,Backdrop } from "@material-ui/core";

import { pathOr } from "ramda";

import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import DashboardIcon from '@material-ui/icons/Dashboard';
import BarChartIcon from '@material-ui/icons/BarChart';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import SettingsIcon from '@material-ui/icons/Settings';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
//Grid
import { Grid, Typography, Button, useTheme, Tooltip } from "@material-ui/core/";
import { AddActiveTile, AddTab, DefaultDashboard, SupportDashboard, SalesDashboard,DashboardSidebar,ManageTabs } from "./components";
import { Alert } from "../../components";
import { Chart, Skeleton } from '../../components';
import { toast } from "react-toastify";
import { textEllipsis } from '../../common/utils';
import Avatar from '@mui/material/Avatar';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';


import { getMetaConfig, getCurrentUser, getUserPreference } from "../../store/actions/config.actions";
import { getCurrentTab, addActiveDashlet, deleteDashboard, addDashboard, renameDashboard, saveDashletLayout } from "../../store/actions/dashboard.actions";
import CircularProgress from '@material-ui/core/CircularProgress';

import SaveIcon from '@material-ui/icons/Save';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import DeleteIcon from '@material-ui/icons/Delete';
//import BrandLogo from "../BrandLogo";
import { logout } from "../../store/actions/auth.actions";
import LogoutIcon from '@mui/icons-material/Logout';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import SortByAlphaIcon from '@mui/icons-material/SortByAlpha';

const useStylesSpeedDialAction = makeStyles((theme) => ({
  staticTooltipLabel: {
    minWidth: '145px',
    fontSize: '0.875rem',
    backgroundColor: (theme.rightBarButtons.background + ' !important'),
    color: theme.rightBarButtons.text,
    border: '1px solid ' + theme.rightBarButtons.text

  },
  fab: {
    backgroundColor: (theme.rightBarButtons.background + ' !important'),
    color: theme.rightBarButtons.text,
    border: '1px solid ' + theme.rightBarButtons.text
  }
}));

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div p={3}>
          <span>{children}</span>
        </div>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}


export default function Dashboard() {
  const { isAuthenticated } = useSelector((state) => state.auth);
  // const [toast, setToast] = useState({ toastVisible: false, toastMessage: '' });

  const {
    config,
    currentUserData,
    userPreference,
    currentUserLoading,
    userPreferenceLoading
  } = useSelector((state) => state.config);
  const { dashboardLoading,dashboardRender, dashboardError, dashboardData, removeDashboard, configureDashletData } = useSelector((state) => state.dashboard);

  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const classesSpeedDialAction = useStylesSpeedDialAction();
  const [value, setValue] = useState(0);
  const [isGoBack, setIsGoBack] = useState(false);
  const [tabHistory, setTabHistory] = useState([]);

  const [renameDashboardValue, setRenameDashboardValue] = useState("");
  const [isRenameDashboard, setIsRenameDashboard] = useState(false);
  const [startJourney, setStartJourney] = useState(false);
  const [renameDashboardLoading, setRenameDashboardLoading] = useState(false);
  const [addedDashlet, setAddedDashlet] = useState(false);
  const [addedDashboard, setAddedDashboard] = useState(false);
  const [date_time_period, setDateTimePeriod] = useState('this_year');
  // const { currentTheme } = useSelector((state) => state.config.themeConfig);
  const [direction] = useState('up');
  const [openDashboardActions, setOpenDashboardActions] = useState(false);
  const [OpenUserActions, setOpenUserActions] = useState(false);
  const [openAddTab, setOpenAddTab] = useState(false);
  const [openAddDashlet, setOpenAddDashlet] = useState(false);
  const [openManageTabDashlet, setOpenManageTabDashlet] = useState(false);
  const [isUpdateLayout, setIsUpdateLayout] = useState(false);
  // const [openSpeedDial, setOpenSpeedDial] = useState(false);
  const [webOptions, setWebOptions] = useState({ 'RSSDashlet': null, 'iFrameDashlet': null });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [removeRecord, setRemoveRecord] = useState("");
  const [alertVisible, setAlertVisibility] = useState(false);
  const [updatedLayout, setUpdatedLayout] = useState({});
  const [updateLayoutLoading, setUpdateLayoutLoading] = useState(false);
  const [leftSideBar, setLeftSideBar] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  //const [toast, setToast] = useState({ toastVisible: false, toastMessage: "" });
  // const [currentSel, setCurrentSel] = useState('');
  const [openC, setOpenC] = useState(false);
  const handleClickAddActiveTileDialogOpen = () => {
    setOpenAddDashlet(true)
  };
  const handleClickManageTabSequenceDialogOpen = () => {
    setOpenManageTabDashlet(true)
  };
  const handleClickUpdateLayout = () => {
    setIsUpdateLayout(true)
  };
  const handleClickAddTabDialogOpen = () => {
    setOpenAddTab(true)
  };
  const renameDashboardPopup = (name) => {
    setOpenC(true);
    setRenameDashboardValue(name)
  };
  const handleCloseC = () => {
    setOpenC(false);
  };
const goBackOnHistory = () =>{
  setIsGoBack(true);
 
  setValue(tabHistory[tabHistory.length -2])
  let myArr= [...tabHistory]
  if(myArr.length===2){
    myArr.pop()
  }
  myArr.pop()
    setTabHistory(myArr);
}
  useEffect(()=>{
   
    // if(tabHistory.length>1){
    let myArr= [...tabHistory]
      myArr.push(value)
      setTabHistory(myArr);
    // }
    // else{
    //   setTabHistory([])
    // }
  },[value])
  const submitRenameFormC = (e) => {
    setRenameDashboardLoading(true)
    let dashName = { "dashName": renameDashboardValue }
    try {
      dispatch(renameDashboard(value, dashName)).then(function (res) {

        if (res.ok) {
          setIsRenameDashboard(true);
          toast(res.ok ? "Dashboard Renamed Succesfully" : "Something Went Wrong");
          setAnchorEl(null);
          setValue(value);
          setOpenC(false);
          setRenameDashboardLoading(false)
        } else {
          toast('Something went wrong!');
        }
      });
    } catch (e) {
      toast("Something went wrong!");
    }

  };
  const handleRenameChangeC = (event) => {
    setRenameDashboardValue(event.target.value);
  };
  const handleClickCustom = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseCustom = () => {
    setAnchorEl(null);
  };
  const confirmDeleteDashlet = (name) => {
  
    setAlertVisibility(true);
    setRemoveRecord({ name: name });
  };
  const deleteDashlet = async () => {
    setAlertVisibility(!alertVisible);
    const id = removeRecord.name;
    try {
      dispatch(deleteDashboard(id)).then(function (res) {
        if (res.ok) {
          toast(res.ok ? "Dashboard Removed Succesfully" : "Something Went Wrong");
          setAnchorEl(null);
          setValue(0);
        } else {
          toast('Something went wrong!');
        }
      });
    } catch (e) {
      toast("Something went wrong!");
    }
  };

  const handleOpenDashboardActions = () => {
    setOpenDashboardActions(openDashboardActions ? false : true);
    // setOpenSpeedDial(openSpeedDial?true:false)

  };
  const handleOpenUserActions = () => {
    setOpenUserActions(OpenUserActions ? false : true);
    // setOpenSpeedDial(openSpeedDial?true:false)

  };
  const stringAvatar = (name) => {
    if(name === undefined) return 'U';
    let nameArray = name.split(' ');
    return {
      sx: {
        bgcolor: 'transparent',
      },
      children: `${pathOr('U', [0,0],nameArray)}${pathOr('', [1,0],nameArray)}`,
    };
  }
  // const [currentTheme, setcurrentTheme] = useState(currentTheme);

  const getConfig = useCallback(
    () => !config && isAuthenticated && dispatch(getMetaConfig()),
    [config, dispatch, isAuthenticated],
  );
  const currentUser = pathOr([], ["data", "attributes"], currentUserData);
  const currentUserId = currentUser["id"];
  const currentUserName = currentUser["full_name"];
  const currentUserType = currentUser["type_c"];
  const getCurrentUserData = useCallback(
    () => isAuthenticated && dispatch(getCurrentUser()),
    [dispatch, isAuthenticated],
  );
  const dashboardTabs = pathOr([], ["attributes", "HomeApp"], userPreference);
  // Capture currency parameter from configureDashlet after toggle
  const currencyAllTab = pathOr(null, ["data", "allTabFilter", 0, "currency"], configureDashletData)
  // Added logic to show currency helper text in selected modules at the top
  const [showCurrent, setShowCurrent] = useState(false);
  let currency;
  // Capture currency parameter from Portfolio summary currency toggle
  const portfolioCurrency = pathOr(null, [0, "dashlets", 0, "data", "data", 0, "value"],dashboardData);
  // Take value of currency from configureDashlet 
  if(currencyAllTab) {
    currency = currencyAllTab;
  } // Take value of currency from portfolio switch by default
  else {
    if(currencyAllTab === null && portfolioCurrency) 
      currency = portfolioCurrency;
  }
  // Retreiving Current tab using value parameter
  const currentDash = pathOr(null, [value, "title"], dashboardData)

  useEffect(() => {
    // Selected module condition to show, with current dashboard dependency
    if(currentDash !== "Portfolio Summary" && currentDash !== "Reports")
      setShowCurrent(true)
    else 
      setShowCurrent(false)
  },[currentDash])

  const [tabsSequence,setTabsSequence] = useState(pathOr([], ["attributes", "customTabs","customTabs"], userPreference));
  const currentAppType=pathOr('IPR', ["pages", value,'parentMenuName'], dashboardTabs) === 'Home' ? "IPR" : pathOr('IPR', ["pages", value,'parentMenuName'], dashboardTabs);
  const dashboardTabsPages = pathOr([], ["attributes", "HomeApp","pages"], userPreference);
  const getDashletTabsData = useCallback(
    () => isAuthenticated && dispatch(getCurrentTab(value, date_time_period)),
    [date_time_period, value,startJourney, dispatch, isAuthenticated],
  );
  const getDashboardData = useCallback(
    () => isAuthenticated && currentUserId && dispatch(getUserPreference(currentUserId)),
    [currentUserId, dispatch, isAuthenticated, removeDashboard, isRenameDashboard],
  );

  const saveUpdatedLayout = () => {
    setUpdateLayoutLoading(true);
    try {
      updatedLayout && updatedLayout['layout'] && updatedLayout['layout'].length > 0 &&
       updatedLayout['layout'].map((item, n) => {
        if(pathOr(false, ["data", "id"], item)){
          updatedLayout['layout'][n]['i']=pathOr(false, ["data", "id"], item);
        }
    })
      
      dispatch(saveDashletLayout(updatedLayout)).then(function (res) {
        if (res.ok) {
          // toast('Layout Updated Successfully!');
          setUpdatedLayout(null);
          setUpdateLayoutLoading(false);
          setIsUpdateLayout(false);
          dispatch(getCurrentTab(value, date_time_period)).then((res)=>{
            toast('Dashboard Updated Successfully!')
          })
        } else {
          toast('Something went wrong!');
        }
      });
    } catch (e) {
      toast('Something went wrong!');
    }
  }

  const dashletTabs = pathOr([], [], dashboardData);
  // useEffect(() => {
  //   // console.log("dashboardTabs",dashboardTabs,dashboardData)
  //   if (dashboardTabs.length === 0) {

  //     try {
  //       dispatch(addDashboard("Home")).then(function (res) {
  //         if (res) {
  //           if (res.status === 200) {
  //             // setToast({ toastVisible: true, toastMessage: "Dashboard Added Successfully!" });
  //             setAddedDashboard(res.data.data.data.current_tab)
  //           } else {
  //             // toast("Duplicate dashboard name!");
  //           }
  //         } else {
  //           toast('Something went wrong!');
  //         }
  //       });
  //     } catch (e) {
  //       toast('Something went wrong!');
  //     }


  //   }

  // }, [])

  useEffect(() => {
    getConfig();
  }, [getConfig]);

  useEffect(() => {
    getCurrentUserData();
  }, [getCurrentUserData]);

  useEffect(() => {
    getDashboardData();
  }, [getDashboardData]);

  useEffect(() => {
    getDashboardData();
    setValue(addedDashboard || value)
    setAddedDashboard(false)
    setAnchorEl(null);
    setOpenC(false);
  }, [addedDashboard]);
  useEffect(() => {
    getDashletTabsData();
  }, [getDashletTabsData]);

  useEffect(() => {
    if(dashboardRender)
    {
      let redirectUrl = localStorage.getItem('redirectUrl');
      localStorage.removeItem('redirectUrl');
      // console.log("dashboardRender",dashboardRender);
      if(redirectUrl)
      history.push(redirectUrl.replace("/app/",""));

    }
  },[dashboardRender]);

  // Added By Deep K On 12-01-2022 to show the dashboard base on AppType
  useEffect(()=>{
    const TypeObj = {'GT' : 'Goal Tracker', 'IPR': 'Home'};
      const getAppType = TypeObj[localStorage.getItem('AppType') != ''?localStorage.getItem('AppType'):'IPR'];
      if(dashboardTabsPages && value === 0){
        let titleIndex= getAppType === 'Home' ? 0 : Object.values(dashboardTabsPages).findIndex(element => element.parentMenuName === getAppType);
        setValue(titleIndex !== -1 ? titleIndex : 0);
      }
  }, [dashboardTabsPages]);


  const renderTabPanel = (tabs, type) => {
    let renderDashboardTabs = [];
  // Added to remove calcuator tab  
  const mName = pathOr('Home', [ value,'parentMenuName'], tabs);
  const newTabs = mName === 'Home'? Object.values(tabs).filter(element => !element.parentMenuName || element.parentMenuName === 'Home' && element.pageTitle !== "Calculator" || element.parentMenuName===''):Object.values(tabs).filter(element => element.parentMenuName === mName);
  tabs && tabs.map((tabContent, tabNum) => (
        renderDashboardTabs.push(
          type === 'tab' ?
            <Tab
              key={tabNum}
              style={{display:Object.values(newTabs).find(element =>element.pageTitle===tabContent.pageTitle)?'block':'none', fontSize: "17px"}}
              label={
                <Tooltip title={tabContent.pageTitle ? tabContent.pageTitle : tabContent.pageTitleLabel} arrow placement="top">
                  <div className={classes.tabName}>
                    {textEllipsis(tabContent.pageTitle ? tabContent.pageTitle : tabContent.pageTitleLabel, 18)}
                  </div>
                </Tooltip>
              }

              {...a11yProps(tabNum)}
              className={classes.tabButton}
            />
            :
            <TabPanel key={"panel" + tabNum} value={value} index={tabNum}>
              <div >
                <Grid container >

                  {tabNum === value ? renderColumns(tabContent, tabNum) : null}
                </Grid>
              </div>
            </TabPanel>
        )
      ))
    return renderDashboardTabs;
  }
  const renderDashlet = (dashlet) => {
    let dashletDetailToRender = [];
    let dashletName = dashboardTabs.dashlets[dashlet] && dashboardTabs.dashlets[dashlet].className;
    dashletDetailToRender.push(<>
      <span className={classes.dashletHeading}>{dashletName && dashletName}</span>
      <Chart
        name={dashletName}
        dataJson={{}}
      />
    </>
    );

    return dashletDetailToRender;
  };
  const renderDashlets = (column) => {
    let dashletsToRender = [];

    column.map((dashlet) => {
      dashletsToRender.push(
        <Grid item xs className={classes.dashlet}>
          {renderDashlet(dashlet)}
        </Grid>,
      );
    });

    return dashletsToRender;
  };
  const renderDashlets2 = (tab) => {

    let dashletsToRender = [];
    let data = dashletTabs[tab];
    switch (data.title) {
      // case 'Leads Dashboard':
      //   data.defaultDashboardData.data.leads.map((column, columnNo) => {
      //     dashletsToRender.push({
      //       id: columnNo,
      //       title: column.status,
      //       label: column.total_leads,
      //       cards: column.data,
      //     })
      //   });
      //   return <Board data={
      //     {
      //       lanes: dashletsToRender
      //     }

      //   } components={{ Card: LeadsDashboardCustomCard }} />;
      // case 'Opportunities Dashboard':
      //   data.defaultDashboardData.data.opportunities.map((column, columnNo) => {
      //     dashletsToRender.push({
      //       id: columnNo,
      //       title: column.sales_stage,
      //       label: column.total_opportunities,
      //       cards: column.data,
      //     })
      //   });
      //   return <Board data={
      //     {
      //       lanes: dashletsToRender
      //     }

      //   } components={{ Card: OpportunitiesDashboardCustomCard }} />;

      case 'Support Dashboard':
        return <SupportDashboard data={data.defaultDashboardData.data} date_time_period={date_time_period} setDateTimePeriod={setDateTimePeriod} />
        break;
      case 'Sales Dashboard':
        return <SalesDashboard data={data.defaultDashboardData.data} date_time_period={date_time_period} setDateTimePeriod={setDateTimePeriod} />
        break;
      default:
        return <DefaultDashboard data={data} addedDashlet={addedDashlet} setAddedDashlet={setAddedDashlet} setOpenAddDashlet={setOpenAddDashlet} updatedLayout={updatedLayout} setUpdatedLayout={setUpdatedLayout} addDashlet={addDashlet} isUpdateLayout={isUpdateLayout} setValue={setValue} value={value} dashboardData={dashboardData} setStartJourney={setStartJourney}/>
        break;
      // <Board data={{
      //   lanes: [{
      //     id: 'lane1',
      //     title: 'Planned Tasks',
      //     label: '12/12',
      //   }, {
      //     id: 'lane2',
      //     title: 'Long Lane name this is i suppose ha!',
      //     cards: [{
      //       id: 'Card3',
      //       name: 'Michael Caine',
      //       dueOn: 'due in a day',
      //     }],
      //   }]
      // }} components={{ Card: CustomCard }} />;
    }

    // data.map((dashlet, dashNum) => {
    //   dashletsToRender.push(
    //     // {
    //     //   id: 'Card1',
    //     //   name: 'John Smith',
    //     //   dueOn: 'due in a day',
    //     //   subTitle: 'SMS received at 12:13pm today',
    //     //   body: 'Thanks. Please schedule me for an estimate on Monday.',
    //     //   escalationText: 'Escalated to OPS-ESCALATIONS!',
    //     //   cardColor: '#BD3B36',
    //     //   cardStyle: { borderRadius: 6, width: '50%', boxShadow: '0 0 6px 1px #BD3B36', marginBottom: 15 }
    //     // }
    //     {
    //       id: 'Card' + dashNum,
    //       name: dashNum,
    //       // dueOn: 'due in a day',
    //       // subTitle: 'SMS received at 12:13pm today',
    //       body: <Chart
    //         name={"Card" + dashNum}
    //         dataJson={{}}
    //       />,
    // label: '30 mins',
    // escalationText: 'Escalated to OPS-ESCALATIONS!',
    //       cardColor: '#BD3B36',
    //       cardStyle: { borderRadius: 6, width: '50%', boxShadow: '0 0 6px 1px #BD3B36', marginBottom: 15 }

    //     }

    //     // renderDashlet2(dashlet)
    //   );
    // });

    // return dashletsToRender;
  };
  const CustomCard = (props) => {
    return (
      <div >
        <header
          style={{
            borderBottom: '1px solid #eee', paddingBottom: 6, marginBottom: 10,
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
            color: props.cardColor
          }}
        >
          <div style={{ fontSize: 14, fontWeight: 'bold' }}>{props.name}</div>
          <div style={{ fontSize: 11 }}>{props.dueOn}</div>
        </header>
        <div style={{ fontSize: 12, color: '#BD3B36' }}>
          <div style={{ color: '#4C4C4C', fontWeight: 'bold' }}>{props.subTitle}</div>
          <div style={{ padding: '5px 0px' }}><i>{props.body}</i></div>
          <div style={{ marginTop: 10, textAlign: 'center', color: props.cardColor, fontSize: 15, fontWeight: 'bold' }}>
            {props.escalationText}
          </div>
        </div>
      </div>
    )
  }

  const LeadsDashboardCustomCard = (props) => {
    return (
      <div >
        <header
          style={{
            borderBottom: '1px solid #eee', paddingBottom: 6, marginBottom: 10,
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
            color: props.status_color
          }}
        >
          <div style={{ fontSize: 14, fontWeight: 'bold' }}>{props.name}</div>
          <div style={{ marginTop: 10, textAlign: 'center', color: props.cardColor, fontSize: 15, fontWeight: 'bold' }}>
            {props.lead_scoring_num}
          </div>
        </header>
        <div style={{ fontSize: 12, color: '#BD3B36' }}>
          <div style={{ color: '#4C4C4C', fontWeight: 'bold' }}>{props.account_name}</div>
          <div style={{ padding: '5px 0px' }}><i>{props.email1}</i></div>

        </div>
      </div>
    )
  }

  const OpportunitiesDashboardCustomCard = (props) => {
    return (
      <div >
        <header
          style={{
            borderBottom: '1px solid #eee', paddingBottom: 6, marginBottom: 10,
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
            color: props.status_color
          }}
        >
          <div style={{ fontSize: 14, fontWeight: 'bold' }}>{props.name}</div>
          <div style={{ fontSize: 11 }}>{props.opportunities_scoring_c}</div>
        </header>
        <div style={{ fontSize: 12, color: '#BD3B36' }}>
          <div style={{ color: '#4C4C4C', fontWeight: 'bold' }}>{props.account_name}</div>
          <div style={{ marginTop: 10, textAlign: 'center', color: props.cardColor, fontSize: 15, fontWeight: 'bold' }}>
            {props.email1}
          </div>
        </div>
      </div>
    )
  }

  const renderColumns = (column, tabNum) => {
    let columnsToRender = [];
    let columnSize = { 1: 12, 2: 6, 3: 4 };


    // for (var i = 0; i < column.columns.length; i++) {
    columnsToRender.push(
      <Grid key={"currentTab" + tabNum} item xs sm={columnSize[1]}>
        {dashletTabs[tabNum] && renderDashlets2(tabNum)}
      </Grid>,
    );

    // }
    return columnsToRender;
  };

  // const loadMetConfig = useCallback(
  //   () => isAuthenticated && dispatch(getMetaConfig()),
  //   [isAuthenticated, dispatch],
  // );

  // useEffect(() => loadMetConfig(), [loadMetConfig]);

  if (!isAuthenticated) {
    history.push("/");
    return;
  }
  

  if (dashboardError) {
    return <h3>{dashboardError}</h3>;
  }

  // if (configLoading) {
  //   return <h2>Loading config...</h2>;
  // }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const addDashlet = (dashlet,dashData={}) => {
    let category = 'module';
    if (dashlet === "RSSDashlet" || dashlet === "iFrameDashlet") {
      category = 'web';
    }else if(dashData){
      category = 'custom';
    }

    try {
      dispatch(addActiveDashlet(dashlet, value, category, category==='custom'?dashData:webOptions)).then(function (res) {
        if (res) {
          if (res.data.meta) {
            toast(res.data.meta.message);
          } else if (res.error) {
            toast(res.message);
          } else {
            // let params = { 'tab': value };
            // dispatch(getDashlet(params)).then(function (resDashboard) {
            // console.log(res.data)
            // setAddedDashlet(resDashboard.data.data.dashlets);
            setAddedDashlet(res.data);
            toast("Dashlet Added Successfully!");
            // })
          }
        } else {
          toast('Something went wrong!');
        }
      });
    } catch (e) {
      toast('Something went wrong!');
    }

  }
  const DashboardActions = [];
  DashboardActions.push({ icon: <LogoutIcon onClick={() => dispatch(logout())} />, name: 'logout', label: 'Logout' })

  if (dashboardTabsPages && dashboardTabsPages.length) {

    DashboardActions.push({ icon: <DashboardIcon onClick={handleClickAddTabDialogOpen} />, name: 'addDashboard', label: 'Add Dashboard' });
  }
  DashboardActions.push({ icon: <BarChartIcon onClick={handleClickAddActiveTileDialogOpen} />, name: 'addActiveTile', label: 'Add Active Tile' })
  DashboardActions.push({ icon: <SortByAlphaIcon onClick={handleClickManageTabSequenceDialogOpen} />, name: 'manageTabSequence', label: 'Manage Tab Sequence' })
  DashboardActions.push({ icon: isUpdateLayout?<SaveIcon onClick={saveUpdatedLayout} />:<SystemUpdateAltIcon onClick={handleClickUpdateLayout} />, name: 'isUpdateLayout', label: isUpdateLayout?'Save Layout':'Update Layout' })

  DashboardActions.push({ icon: <DeleteIcon onClick={() => confirmDeleteDashlet(value)} />, name: 'deleteDashboard', label: 'Delete Dashboard' })
  DashboardActions.push({ icon: <BorderColorIcon onClick={() => renameDashboardPopup(dashletTabs[value]['title'] || '')} />, name: 'renameDashboard', label: 'Rename Dashboard' })

  const userActions = [];
  if(currentUserType === 'Agent' || process.env.REACT_APP_CRM_USERNAME == currentUserId){
    userActions.push({ icon: <LogoutIcon onClick={() => dispatch(logout())} />, name: 'logout', label: 'Logout' });
  }
  // userActions.push({ icon: <DashboardSidebar key="dashboardSidebar" menus={dashboardTabsPages} setValue={setValue} setLeftSideBar={setLeftSideBar} leftSideBar={leftSideBar} value={value}/>, name: 'menus', label: 'Menus' });
  userActions.push({ icon: <MenuIcon onClick={() => setLeftSideBar({...leftSideBar,['left']: true})}/>, name: 'menus', label: 'Menus' });
  userActions.push({ icon: <PersonIcon />, name: 'username', label: currentUserName });

  return (
    <MuiThemeProvider theme={getMuiTheme(theme)}>
      <div >
        <Grid 
        container
          direction="row"
          justify="space-between"
          alignItems="center"
          className={classes.dashWidth}
          >
          <Grid 
          container
            direction="row"
            justify="center"
            alignItems="center" className={classes.navBackground} style={{display: 'none'}}>
                <Grid item xs={1}> <DashboardSidebar key="dashboardSidebar" menus={dashboardTabsPages} setValue={setValue} value={value} setLeftSideBar={setLeftSideBar} leftSideBar={leftSideBar}/></Grid>
           {/* {tabHistory.length>1?<Grid item xs={1}>
             
                <IconButton  onClick={()=>goBackOnHistory()} style={{color:'#FFFFFF'}} aria-label="Example"><ArrowBackIosNewIcon/> </IconButton></Grid>:null} 
            <Grid item xs={tabHistory.length>1?10:11} >*/}
            <Grid item xs={10} >

               <Typography variant="h5" gutterBottom component="div" className={classes.brandLogoTitle}>
               
               {currentAppType}
      </Typography>
     
      </Grid>
      <Grid item xs={1} >

      {localStorage.getItem('AppType')===''?<IconButton  onClick={() => dispatch(logout())} style={{color:'#FFFFFF'}} aria-label="Example"><ExitToAppIcon /> </IconButton>:null}
      </Grid>
     
          </Grid>
          <Grid item xs sm >
            <Grid item xs className={classes.navTabs} >
              <Grid item >
                
                <Tabs
                      classes={{ root: classes.rootTabs, scroller: classes.scroller }}
                  value={value}
                  onChange={handleChange}
                  indicatorColor="primary"
                  textColor="primary"
                  // variant="scrollable"
                  // scrollButtons="auto"
                  variant={"scrollable"}
                  scrollButtons={"on"}
                  // allowScrollButtonsMobile={true}
                  aria-label="scrollable auto tabs example"
                 
               
                >

                  {renderTabPanel(dashboardTabsPages, "tab")}
                </Tabs>

              </Grid>
               <Grid item className={classes.parentBackground}>
                <span className={classes.cstmWidth}>

                  {/* <Button className={classes.settingBtn} aria-controls="fade-menu" aria-haspopup="true" onClick={handleClickCustom}>
                    <SettingsIcon />
                  </Button>

                  <Menu
                    id="fade-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleCloseCustom}
                    TransitionComponent={Fade}

                  >
                    <MenuItem title="Add Dashboard" className={classes.selectFontDash} onClick={handleClickAddTabDialogOpen}>Add Dashboard</MenuItem>
                    {value !== 0 ? <MenuItem title="Delete Dashboard" className={classes.selectFontDash} onClick={() => confirmDeleteDashlet(value)}
                    >
                      Delete Dashboard
                  </MenuItem> : null}
                    <MenuItem title="Rename Dashboard"
                      onClick={() => renameDashboardPopup(dashletTabs[value]['title'] || '')}
                      className={classes.selectFontDash}
                    >
                      Rename Dashboard
                  </MenuItem>
                  </Menu> */}
                  <Alert
                    title="Remove Dashboard"
                    msg="Are you sure you want to Delete the Current Dashboard?"
                    open={alertVisible}
                    agreeText={"Yes"}
                    disagreeText={"No"}
                    handleClose={() => setAlertVisibility(!alertVisible)}
                    onAgree={deleteDashlet}
                  />
                  <Dialog
                    open={openC}
                    onClose={handleCloseC}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <form name="adddashboardC" >
                      <DialogTitle id="alert-dialog-title">Rename Dashboard</DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">

                          <div className={classes.root}>
                            <TextField
                              id="dashName"
                              label="Enter Dashboard Name:"
                              style={{ margin: 8 }}
                              placeholder="Dashboard Name..."
                              helperText=""
                              fullWidth
                              margin="normal"
                              value={renameDashboardValue}
                              onChange={handleRenameChangeC}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />

                          </div>

                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        {renameDashboardLoading ? <Button variant="contained" size="small" color="primary" disabled={!renameDashboardValue} >
                          Renaming...
                                </Button> : <Button variant="contained" size="small" color="primary" disabled={!renameDashboardValue} type='button' onClick={submitRenameFormC}>
                          Submit
                                </Button>}


                        <Button variant="contained" size="small" autoFocus onClick={handleCloseC} color="primary">
                          Close
                                </Button>
                      </DialogActions>
                    </form>
                  </Dialog>
                </span>
              </Grid> 
            </Grid>
          </Grid>
           {
            // Added logic to show helper text in Tabs at the top. 
            showCurrent && !dashboardLoading &&
            <Grid 
              container
              className={classes.textBanner}
            >
              <Grid 
                item
                xs={12}
                style={{ display: "flex", alignItems: "center", justifyContent: "center"}}
              >
                <Typography variant="body2" style={{ padding: "4px"}}>
                  {
                    currency === "PHP" 
                    ?(
                      <>
                        You are viewing your <strong> peso-denominated </strong> policy/ies.  If you have dollar-denominated policies and wish to view them, go to the Portfolio Summary tab and toggle the switch to US dollars.
                      </> 
                    ): currency === "USD"
                    ? (
                      <>
                        You are viewing your <strong> dollar-denominated </strong> policy/ies. If you have peso-denominated policies and wish to view them, go to the Portfolio Summary tab and toggle the switch to PH peso.
                      </>
                    ):''
                  }
                </Typography>
              </Grid>
            </Grid>
           } 
         
        </Grid>
        {/* <Skeleton count={7} /> */}
        {dashboardLoading || currentUserLoading || userPreferenceLoading? <Backdrop className={classes.backdrop} open={true}>
        {/* <CircularProgress color="inherit" />  */}
        {/* <SkeletonShell layout='listView' display /> */}
        <Skeleton count={7} />
      </Backdrop>:renderTabPanel(dashboardTabsPages, 'panel')}
        <SpeedDial
          ariaLabel="User Actions"
          className={classes.userSpeedDial}
          icon={<Tooltip title={currentUserName || ''} placement="left-start">
                <Avatar {...stringAvatar(currentUserName || '')} />
              </Tooltip>}
          // onClose={handleCloseDashboardActions}
          onClick={handleOpenUserActions}
          open={OpenUserActions}
          direction={direction}
          >
          {userActions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.label}
              tooltipOpen
              onClick={handleOpenUserActions}
              classes={classesSpeedDialAction}
              TooltipClasses={classesSpeedDialAction}
            />
          ))}
          </SpeedDial>
        {(dashletTabs[value] && (process.env.REACT_APP_CRM_USERNAME == currentUserId && dashletTabs[value]['title'] !== 'Sales Dashboard' && dashletTabs[value]['title'] !== 'Support Dashboard' && dashletTabs[value]['title'] !== 'Leads Dashboard' && dashletTabs[value]['title'] !== 'Opportunities Dashboard')) ?
          <SpeedDial
            ariaLabel="Dashboard Actions"
            className={classes.speedDial}
            icon={<SpeedDialIcon />}
            // onClose={handleCloseDashboardActions}
            onClick={handleOpenDashboardActions}
            open={openDashboardActions}
            direction={direction}
          >
            {DashboardActions.map((action) => (
              <SpeedDialAction
                key={action.name}
                icon={action.icon}
                tooltipTitle={action.label}
                tooltipOpen
                onClick={handleOpenDashboardActions}
                classes={classesSpeedDialAction}
                TooltipClasses={classesSpeedDialAction}
              />
            ))}
          </SpeedDial>
          : null}
          
        {openAddTab ? <AddTab setAddedDashboard={setAddedDashboard} openAddTab={openAddTab} setOpenAddTab={setOpenAddTab} /> : null}
        {openManageTabDashlet ? <ManageTabs  openManageTabDashlet={openManageTabDashlet} setOpenManageTabDashlet={setOpenManageTabDashlet} dashboardTabsPages={dashboardTabsPages} currentAppType={currentAppType} setTabsSequence={setTabsSequence}/> : null}
        {openAddDashlet ? <AddActiveTile addDashlet={addDashlet} openAddDashlet={openAddDashlet} setOpenAddDashlet={setOpenAddDashlet} webOptions={webOptions} setWebOptions={setWebOptions} /> : null}

      </div>
    </MuiThemeProvider>
  );
}

// export default Dashboard;